import React, { useState, useEffect } from 'react';
// Import components
import HeroSection from './HeroSection';
import CTASection from './CTASection';
import Footer from './Footer';
import Metrics from './DashboardMetricsSection';
import DashboardSolutions from './DashboardSolutions';
import DashboardCarousel from './DashboardCarousel'

const LandingPage = () => {
    // State for parallax scrolling effect
    const [parallaxOffset, setParallaxOffset] = useState(0);
    // Handle scroll event for parallax effect
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setParallaxOffset(scrollY * 0.5); // Adjust multiplier for parallax intensity
        };
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
        // Clean up
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="min-h-screen bg-slate-900 text-white">
            <HeroSection parallaxOffset={parallaxOffset} />
            <main>
                <Metrics />
                <DashboardSolutions />
                <DashboardCarousel />
                <CTASection />                
            </main>
            <Footer />
        </div>
    );
};

export default LandingPage;